export var jast = function jast(query) {
  var represents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    query: query,
    represents: represents,
    errors: errors
  };
};